export enum PurchaseTypeEnum {
  SUBSCRIPTION_RENEWABLE,
  SUBSCRIPTION_NON_RENEWABLE,
  ONETIME_CONSUMABLE,
  ONETIME_NONCONSUMABLE,
  FREE,
}

export enum PurchaseSourceEnum {
  APPLE = 0,
  HUAWEI = 1,
  GOOGLE = 2,
  OFFLINE = 3,
  INTERNAL = 4,
  FREE = 5,
  VOUCHER = 6,
  STRIPE = 7,
  TPAY = 8,
  MONDIAPAY_VODAFONE = 10,
  MONDIAPAY_ETISALAT = 11,
  MONDIAPAY_ORANGE = 12,
  MONDIAPAY_WE = 13,
  STCPay = 14,
  MOBIMIND_KSA_STC = 16,
  MOBIMIND_KSA_MOBILY = 17,
  MOBIMIND_KSA_ZAIN = 18,
  MOYASAR_APPLE_PAY = 19,
  MOYASAR_STCPAY = 20,
  MOYASAR_CREDITCARD = 21,
  MEDIAWORLD_ZAIN = 22,
  MEDIAWORLD_JAWWAL = 23,
  TAMARA = 24,
  REWARD = 25,
  MOBIMIND_KWT_ZAIN = 26,
  MOBIMIND_KWT_OOREDOO = 27,
  MOBIMIND_KWT_STC = 28,
}

export const purchaseSourceOptionList = [
  { label: 'APPLE', value: PurchaseSourceEnum.APPLE },
  { label: 'HUAWEI', value: PurchaseSourceEnum.HUAWEI },
  { label: 'GOOGLE', value: PurchaseSourceEnum.GOOGLE },
  { label: 'OFFLINE', value: PurchaseSourceEnum.OFFLINE },
  { label: 'INTERNAL', value: PurchaseSourceEnum.INTERNAL },
  { label: 'FREE', value: PurchaseSourceEnum.FREE },
  { label: 'VOUCHER', value: PurchaseSourceEnum.VOUCHER },
];
export enum ProductTypeEnum {
  SubscriptionProduct,
  GiftProduct,
  ContentProduct,
}

export interface ProductOutput {
  id: number;
  purchaseType: PurchaseTypeEnum;
  purchaseProviderKey: string;
  purchaseSource: PurchaseSourceEnum;
  groupId: string | null;
  productType: ProductTypeEnum;

  duration: number;
  productDuration: number;
  subscriptionPeriod: string | null;
  name: string | null;
}

export interface SubscriptionHistoryOutput {
  purchaseSource: PurchaseSourceEnum;

  customerProductId: number;
  purchaseType: PurchaseTypeEnum;

  purchaseProviderKey: string | null;
  productType: ProductTypeEnum;

  startDate: string;
  expirationDate: string | null;
  createdDate: null;
}
